export enum Perms {
  STANDARD = 'standard',
}
